import dayjs from 'dayjs';
import { isNil } from 'lodash';
import { isNilString, validateEmail, validateUrl, validatePhone } from './string';

export const FORM_VALIDATIONS = {
  email:
    (required = true) =>
    (value: string) => {
      if (isNilString(value) && !required) {
        return null;
      }

      return validateEmail(value) ? null : 'Please provide a valid email.';
    },
  exists: (label: string) => (value: any) => {
    return isNil(value) ? `Please provide ${label}.` : null;
  },
  name:
    (label: string, required = true) =>
    (value: string) => {
      if (isNilString(value) && !required) {
        return null;
      }

      if (value && value.length >= 2) {
        return null;
      }

      return `${label} must be at least 2 characters long`;
    },
  basicText:
    (label: string, count: number, required = true) =>
    (value?: string) => {
      if (isNilString(value) && !required) {
        return null;
      }

      if (value && value.length >= count) {
        return null;
      }

      return `${label} must be at least ${count} characters long`;
    },
  words: (label: string, count: number) => (value: string) =>
    value && value.split(' ').filter((it) => it).length > count
      ? null
      : `Please provide a valid ${label}`,

  address1: (val: string) => {
    return val.length >= 3
      ? null
      : 'Address line 1 must be at least 3 characters long';
  },
  address2: (val: string) => {
    if (isNilString(val)) {
      return null;
    }

    if (val) {
      return val.length >= 3
        ? null
        : 'Address line 1 must be at least 3 characters long';
    }

    return null;
  },
  city: (val: string) => {
    return val.length >= 3 ? null : 'City must be at least 3 characters long';
  },
  zipCode: (val: number | string) => {
    return String(val).length === 5 ? null : 'Zip Code must be 5 digits long';
  },
  state: (val: string) => {
    return val.length >= 2 ? null : 'A state must be selected';
  },
  url: (val: string) => {
    return validateUrl(val) ? null : 'Must be a valid URL';
  },
  phone: (required = true) => (val: string) => {
    if (isNilString(val) && !required) {
      return null;
    }
    return validatePhone(val)
      ? null : 'Please provide a valid phone number (10 digits)';
  },
  noop: (val: any) => null,
  list:
    (label: string, required: boolean, count = 1) =>
    (val: string[]) => {
      if (!required) {
        return null;
      }

      if (val.length < count) {
        return `Please provide a least ${count} ${label}`;
      }

      return null;
    },
  year: (val?: number | string) => {
    if (!val) {
      return 'Please provide a year';
    }
    const currentYear = dayjs().year();

    if (String(val).length < 4) {
      return 'Please provide a valid year';
    }

    if (Number(val) > currentYear) {
      return 'Year cannot be in the future';
    }

    return null;
  },
};
